import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

/**
 * 标记消息为已读
 * @param {number} id - 消息ID
 * @returns {Promise}
 */
export const mark_message_read = (id) => {
  // 后端使用PUT方法，参数从Body JSON传递
  return api.put(`${ApiEndpointConstants.MARK_MESSAGE_READ}`, { id });
};

